import {setHours, setMinutes, setSeconds} from 'date-fns';
import {TimeType} from 'platform/components';

import {isNil} from 'ramda';

import {getApiDateTimeString, Nullish} from 'shared/web';

const END_OF_DAY_HOURS = 23;
const END_OF_DAY_MINUTES = 59;
const END_OF_DAY_SECONDS = 59;

export function getReserveUntilAtString(date: Date, time: TimeType | Nullish): string {
  if (isNil(time)) {
    const endOfDay = setSeconds(
      setMinutes(setHours(date, END_OF_DAY_HOURS), END_OF_DAY_MINUTES),
      END_OF_DAY_SECONDS
    );

    return getApiDateTimeString(endOfDay);
  }

  const [hours, minutes] = time.split(':');
  const mergedDate = setSeconds(setMinutes(setHours(date, Number(hours)), Number(minutes)), 0);

  return getApiDateTimeString(mergedDate);
}
